<template >
  <section v-if="school">
    <v-toolbar color="#D0E8FF" flat class="mt-0 pa-0" height="40">
      <v-tabs v-model="selectedDepartment" height="40">
        <v-tab v-for="(department, iindex) in departments" :key="iindex">
          <span>{{ department.name }}</span>
        </v-tab>
      </v-tabs>
    </v-toolbar>
    <v-tabs-items v-model="selectedDepartment">
      <v-tab-item v-for="(department, cndex) in departments" :key="cndex">
        <section>
          <v-toolbar color="#fff" flat class="mt-0 pa-0" height="40">
            <v-tabs v-model="selectedClass" height="40">
              <v-tab
                v-for="(aclass, iindex) in department.classes"
                :key="iindex"
                @click="_selectAClass(aclass)"
              >
                <span>{{ aclass.name }}</span>
              </v-tab>
            </v-tabs>
          </v-toolbar>
          <hr />
          <v-tabs-items v-model="selectedClass">
            <v-tab-item
              v-for="(aclass, cndex) in department.classes"
              :key="cndex"
            >
              <section
                v-if="aclass.students != null"
                style="height: 600px; overflow-y: scroll"
              >
                <!-- <p v-for="(student, sindex) in aclass.students" :key="sindex">
                    {{ student.name }}
                  </p> -->

                <!-- <v-btn @click="_view(aclass)">view</v-btn>   -->

                <final-year-scores
                  :schoolId="schoolId"
                  :departmentId="aclass.department.id"
                  :programId="aclass.id"
                ></final-year-scores>
              </section>
            </v-tab-item>
          </v-tabs-items>
        </section>
      </v-tab-item>
    </v-tabs-items>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </section>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import FinalYearScores from "@/components/school/admin/XProgramFinalexamScores";
export default {
  name: "SDepartments",
  data() {
    return {
      loading: false,
      school: null,
      departments: [],
      selectedDepartment: null,
      allClasses: [],
      selectedClass: null,
    };
  },
  components: {
    FinalYearScores,
  },
  computed: {},
  watch: {
    selectedDepartment: function (val) {
      //this.selectedDepartment = this.departments[0];
      console.log(val)
    },
  },
  mounted() {
    this.selectedDepartment = this.departments[0];
    console.log(this.departments);
  },
  methods: {
    _view(aclass) {
      // this.$router.push({
      //   name: "SProgramLessons",
      //   params: {
      //     schoolId: this.school.id,
      //     departmentId: aclass.department.id,
      //     programId: aclass.id,
      //   },
      // });
    },
    _selectAClass(aclass) {
      if (!aclass.students) {
        fb.db
          .collection("schools")
          .doc(this.schoolId)
          .collection("students")
          .where("program", "==", aclass.ref)
          .orderBy("name")
          .get()
          .then((snapshot) => {
            aclass.students = [];
            this.loading = true;
            snapshot.docs.forEach(async (doc) => {
              if (doc.exists) {
                let student = doc.data();
                student.id = doc.id;
                student.ref = doc.ref;
                aclass.students.push(student);
              }
            });
            this.loading = false;
          });
      } else {
      }
    },
    async _setupp() {
      var counter = 0;
      var doc = await fb.db.collection("schools").doc(this.schoolId).get();

      if (doc.exists) {
        let school = doc.data();
        school.id = doc.id;
        school.ref = doc.ref;
        this.school = school;
        var ddoc = await this.school.ref
          .collection("departments")
          .where("startYear", "==", this.school.currentYear)
          .orderBy("index", "desc")
          .get();
        if (!ddoc.empty) {
          ddoc.docs.forEach(async (doc) => {
            if (doc.exists) {
              let department = doc.data();
              department.id = doc.id;
              department.ref = doc.ref;
              department.classes = []
              var pp = await department.ref.collection('programs').orderBy("name", "asc").get()
              
              pp.docs.forEach((doc)=>{
                 let aclass = doc.data();
                      aclass.id = doc.id;
                      aclass.ref = doc.ref;
                      aclass.department = department;
                      department.classes.push(aclass);
                      this.allClasses.push(aclass);
              
              })
              this.selectedClass = 0
              this._selectAClass(this.allClasses[this.selectedClass])
              this.departments.push(department);
              this.selectedDepartment = 0;
            }
          });
        }
      }

      // fb.db
      //   .collection("schools")
      //   .doc(this.schoolId)
      //   .get()
      //   .then((doc) => {
      //     let school = doc.data();
      //     school.id = doc.id;
      //     school.ref = doc.ref;
      //     this.school = school;
      //     school.ref
      //       .collection("departments")
      //       .where("startYear", "==", this.school.currentYear)
      //       .orderBy("index", "desc")
      //       .onSnapshot((querySnapshot) => {
      //         this.departments = [];
      //         querySnapshot.forEach((doc) => {
      //           let department = doc.data();
      //           department.id = doc.id;
      //           department.ref = doc.ref;

      //           fb.db
      //             .collection(
      //               "schools/" +
      //                 this.schoolId +
      //                 "/departments/" +
      //                 department.id +
      //                 "/programs"
      //             )
      //             .orderBy("name", "asc")
      //             .onSnapshot((querySnapshot) => {
      //               department.classes = [];
      //               querySnapshot.forEach((doc) => {
      //                 let aclass = doc.data();
      //                 aclass.id = doc.id;
      //                 aclass.ref = doc.ref;
      //                 aclass.department = department;
      //                 department.classes.push(aclass);
      //                 this.allClasses.push(aclass);
      //               });
      //             });

      //           if (counter == 0) this.selectedDepartment = department;
      //           counter++;
      //           this.departments.push(department);
      //         });
      //       });
      //   });
    },

    goDetail(dep) {
      this.$router.push({
        name: "DepartmentDetail",
        params: { schoolId: this.schoolId, departmentId: dep.id },
      });
    },
    goDetailLesson(dep) {
      this.$router.push({
        name: "SCategories",
        params: { schoolId: this.schoolId, departmentId: dep.id },
      });
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  props: {
    schoolId: {
      required: true,
    },
  },
  created() {
    var _this = this;
    if (this.schoolId != null && this.schoolId != "") this._setupp();
  },
  filters: {
    formatDate(val) {
      if (val != null) {
        if (!val) {
          return "-";
        }
        let date = val.toDate();
        return moment(date).fromNow();
      }
      return "-";
    },
  },
};
</script>

